export function yen(price: number): string {
  // toLocaleString('ja-JP',  { style: 'currency', currency: 'JPY' }) は全角の円マークを付けるので使わない
  return '¥' + price.toLocaleString('ja-JP')
}

export function yenKanji(price: number): string {
  return price.toLocaleString('ja-JP') + '円'
}
